export default __webpack_public_path__ + "static/media/step4-4.74883755.jpg";